/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * 
 * @export
 * @interface ReportSalesVersusCosts
 */
export interface ReportSalesVersusCosts {
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof ReportSalesVersusCosts
     */
    date: ShiftiePlainDate;
    /**
     * 
     * @type {number}
     * @memberof ReportSalesVersusCosts
     */
    icrTouchNetSales: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportSalesVersusCosts
     */
    shiftCostsScheduled: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportSalesVersusCosts
     */
    timesheetCostsWorked: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportSalesVersusCosts
     */
    leaveRequestCostsWorked: number | null;
}

/**
 * Check if a given object implements the ReportSalesVersusCosts interface.
 */
export function instanceOfReportSalesVersusCosts(value: object): value is ReportSalesVersusCosts {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('icrTouchNetSales' in value) || value['icrTouchNetSales'] === undefined) return false;
    if (!('shiftCostsScheduled' in value) || value['shiftCostsScheduled'] === undefined) return false;
    if (!('timesheetCostsWorked' in value) || value['timesheetCostsWorked'] === undefined) return false;
    if (!('leaveRequestCostsWorked' in value) || value['leaveRequestCostsWorked'] === undefined) return false;
    return true;
}

export function ReportSalesVersusCostsFromJSON(json: any): ReportSalesVersusCosts {
    return ReportSalesVersusCostsFromJSONTyped(json, false);
}

export function ReportSalesVersusCostsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportSalesVersusCosts {
    if (json == null) {
        return json;
    }
    return {
        
        'date': ShiftiePlainDateFromJSON(json['date']),
        'icrTouchNetSales': json['icrTouchNetSales'],
        'shiftCostsScheduled': json['shiftCostsScheduled'],
        'timesheetCostsWorked': json['timesheetCostsWorked'],
        'leaveRequestCostsWorked': json['leaveRequestCostsWorked'],
    };
}

  export function ReportSalesVersusCostsToJSON(json: any): ReportSalesVersusCosts {
      return ReportSalesVersusCostsToJSONTyped(json, false);
  }

  export function ReportSalesVersusCostsToJSONTyped(value?: ReportSalesVersusCosts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': ShiftiePlainDateToJSON(value['date']),
        'icrTouchNetSales': value['icrTouchNetSales'],
        'shiftCostsScheduled': value['shiftCostsScheduled'],
        'timesheetCostsWorked': value['timesheetCostsWorked'],
        'leaveRequestCostsWorked': value['leaveRequestCostsWorked'],
    };
}

